import React from 'react'

import '../stylesheets/components/Loader.scss'

export default class Loader extends React.Component {
    render() {
        return <div className="Loader" />
    }
}
